import { HttpService } from 'core/modules/network-service';
import { get, merge } from 'lodash';
import { getVisibleItems, isVisible } from 'resolvers/getVisibleEntities';
import { SERVICE_RESPONSE_STATUS, CRUD_OPERATION } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberCheckoutPaymentOptions defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberCheckoutPaymentOptionsService } from 'services/memberCheckoutPaymentOptions';
 *
 * // create service instance and send/cancel request
 * const memberCheckoutPaymentOptionsService = new MemberCheckoutPaymentOptionsService();
 * const result = await memberCheckoutPaymentOptionsService.fetchData( '<user-id>' ); // fetch data
 * memberCheckoutPaymentOptionsService.cancel(); // cancel an active request
 */
export class MemberCheckoutPaymentOptionsService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract data
            const visibility = get( response, 'body.component.visibility', {} );
            const modifyActions = get( response, 'body.component.structure.modifyActions', {} );
            const addAction = get( response, 'body.component.structure.addAction', {} );
            const component = get( response, 'body.component', {} );
            
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    options: get( response, 'body.component.data.options', {} ),
                    addAction: isVisible( addAction, visibility ) ? addAction: {},
                    modifyActions: getVisibleItems( modifyActions, visibility ),
                    widgetConfig: get( response, 'body.component.structure.widgetConfig', {} ),
                    changeConfirmation: get( component, 'structure.widgetConfig.changeConfirmation', {} ),
                    defaultDescription: isVisible( get( component, 'structure.widgetConfig.defaultDescription', {} ), visibility ) ? get( response, 'body.component.structure.widgetConfig.defaultDescription', {} ): {},
                    
                    // clearSelection: get( response, 'body.component.structure.clearSelection', {} ),
                    ...get( response, 'body.component.data.state', {} )
                },
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

     // make request and fetch data
     async setDefaultPaymentInfo( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }

    // make request and fetch data
    async deletePaymentInfo( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };

        } catch( error ) {
            
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }

    // make request and fetch data
    async submitEditedPaymentInfo( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {
                    context: {
                        operation: CRUD_OPERATION.UPDATE,
                    },
                } ),
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }

    // submits payment card activation request
    async submitActivatePaymentInfoRequest( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) )
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }

    // submits payment card activation request
    async submitToggleHsaFsaPaymentInfoRequest( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) )
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }
}
